import { Link } from "react-router";
import { LEGAL_LINKS } from "./legalContent";

/** Links to every policy: the footer of each plain page and the town's account menu. */
export function LegalFooter() {
  return (
    <footer className="legal-footer small" aria-label="Terms and policies">
      {LEGAL_LINKS.map((l, i) => (
        <span key={l.slug}>
          {i > 0 ? " · " : null}
          <Link to={`/legal/${l.slug}`}>{l.label}</Link>
        </span>
      ))}
    </footer>
  );
}
